import { MAX_NAME_LENGTH } from 'constants/staffItemConst'

export const truncateString = str =>
  str.length <= MAX_NAME_LENGTH ? str : str.slice(0, MAX_NAME_LENGTH) + '..'
